exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timeline-label[data-v-fd25892c]{font-size:.875rem;font-weight:500}.timeline-date[data-v-fd25892c]{font-size:.75rem;color:rgba(0,0,0,.6)}", ""]);

// exports
